<app-plan-findings-panel
  data-testid="findings-list"
  class="block transition-opacity"
  [class.opacity-60]="muted()"
  [attr.aria-busy]="muted() || null"
  [findings]="findings()"
  [entityTypeLabels]="entityTypeLabels()"
  [loading]="!live() && busy()"
  [planNeverChecked]="!live() && neverChecked()"
  [findingsAreStale]="!live() && stale()"
  [checkFailed]="!live() && phase() === 'FAILED'"
  [unavailable]="!live() && phase() === 'UNAVAILABLE'"
  [live]="live()"
  [occurrenceFilter]="occurrenceFilter()"
  [hiddenNoteKey]="hiddenNoteKey()"
  [startExpanded]="true"
  [framed]="false"
  [listScrolls]="false"
  (filtersCleared)="resetScope()"
  (checkRequested)="requestCheck()">
  <div findingsScope class="flex flex-wrap items-center gap-2">
    <div
      class="gx-segmented p-px"
      role="group"
      [attr.aria-label]="'features.plan.panel.findings.scope' | translate">
      <button
        type="button"
        data-testid="findings-scope-all"
        class="seg px-2 py-px text-[11px] focus-visible:shadow-[var(--shadow-focus)]"
        [class.is-active]="activeScope() === 'all'"
        [attr.aria-pressed]="activeScope() === 'all'"
        (click)="setScope('all')">
        {{ 'features.plan.panel.findings.scope_all' | translate }}
      </button>
      @if (selectedOffered()) {
        <button
          type="button"
          data-testid="findings-scope-selected"
          class="seg px-2 py-px text-[11px] focus-visible:shadow-[var(--shadow-focus)] disabled:cursor-not-allowed disabled:opacity-50"
          [class.is-active]="activeScope() === 'selected'"
          [attr.aria-pressed]="activeScope() === 'selected'"
          [attr.aria-describedby]="selectedDisabled() ? 'findings-select-all-reason' : null"
          [disabled]="selectedDisabled()"
          (click)="setScope('selected')">
          {{ 'features.plan.panel.findings.scope_selected' | translate }}
        </button>
      }
    </div>
    @if (selectedDisabled()) {
      <span id="findings-select-all-reason" class="text-text-tertiary text-[11px]">
        {{ 'features.plan.panel.findings.select_all_disabled' | translate }}
      </span>
    }
  </div>
</app-plan-findings-panel>
